import { DeleteOutlined, FileOutlined } from "@ant-design/icons";
import { Button, Image, Typography } from "antd";
import useTranslation from "../../localization/useTranslation";
import resolveAttachmentUrl from "../../utilities/resolveAttachmentUrl";
import CenteredPopconfirm from "./CenteredPopconfirm";

/**
 * Thumbnail grid for stored attachments: images open in a preview gallery,
 * other files open in a new tab. Pass `onDelete` to show a remove button.
 */
const AttachmentsPreview = ({
  attachments,
  onDelete,
  deletingId = null,
  deleteConfirmTitle,
  size = 120,
}) => {
  const { t } = useTranslation();
  const visible = (Array.isArray(attachments) ? attachments : []).filter(
    (attachment) => attachment && !attachment.deleted_at,
  );

  if (visible.length === 0) {
    return null;
  }

  return (
    <Image.PreviewGroup>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
        {visible.map((attachment) => {
          const url = resolveAttachmentUrl(attachment.path);
          return (
            <div
              key={attachment.id ?? attachment.path}
              style={{
                width: size,
                padding: 8,
                border: "1px solid #f0f0f0",
                borderRadius: 8,
                display: "flex",
                flexDirection: "column",
                gap: 6,
              }}
            >
              {attachment.type === "image" ? (
                <Image
                  src={url}
                  alt={attachment.name}
                  height={Math.round(size * 0.65)}
                  style={{ objectFit: "cover", width: "100%" }}
                />
              ) : (
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    height: Math.round(size * 0.65),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 32,
                  }}
                >
                  <FileOutlined />
                </a>
              )}
              <Typography.Text
                ellipsis={{ tooltip: attachment.name }}
                style={{ fontSize: 12 }}
              >
                <a href={url} target="_blank" rel="noreferrer">
                  {attachment.name}
                </a>
              </Typography.Text>
              {onDelete ? (
                <CenteredPopconfirm
                  title={deleteConfirmTitle}
                  onConfirm={() => onDelete(attachment.id)}
                  okText={t("common.yes")}
                  cancelText={t("common.no")}
                >
                  <Button
                    size="small"
                    danger
                    icon={<DeleteOutlined />}
                    loading={deletingId === attachment.id}
                  >
                    {t("common.delete")}
                  </Button>
                </CenteredPopconfirm>
              ) : null}
            </div>
          );
        })}
      </div>
    </Image.PreviewGroup>
  );
};

export default AttachmentsPreview;
